import React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { H3, Text } from '@mxenabled/mxui'
import { CheckCircle, CircleIcon } from '@mxenabled/mx-icons'

import { formatCurrency } from '../../../../../common'
import type { StepChartBlockData } from '../../../../../core/types/InsightsInstanceSlotData'

import { getStepColor } from '../utils'

const MILESTONES = [100, 500, 1000] as const
const MILESTONE_INDICES = [0, 1, 2] as const

// TODO: Update bgColor, borderColor, and color based on the variants.

const WithText = ({ slotData }: { slotData: StepChartBlockData }) => {
  const { completed_steps: completedSteps, label_1, label_2 } = slotData
  const allCompleted = MILESTONES.length === completedSteps

  return (
    <Stack
      sx={{
        bgcolor: 'success.lighter',
        border: '1px solid',
        borderColor: 'success.main',
        borderRadius: '8px',
        gap: 16,
        py: 16,
      }}
    >
      <Stack sx={{ px: 16 }}>
        <Text color="text.secondary" variant="tiny">
          {label_1}
        </Text>
        <H3 color="success.dark">{label_2}</H3>
      </Stack>
      <Stack sx={{ height: 40 }}>
        <Stack sx={{ flexDirection: 'row' }}>
          {MILESTONE_INDICES.map((index) => {
            const completed = index < completedSteps
            const Icon = completed ? CheckCircle : CircleIcon

            return (
              <React.Fragment key={index}>
                <Box
                  sx={(theme) => ({
                    bgcolor: getStepColor(theme, completed),
                    height: 2,
                    mt: 12,
                    width: 54,
                  })}
                />
                <Stack sx={{ alignItems: 'center', width: 24 }}>
                  <Icon
                    filled={true}
                    size={24}
                    sx={(theme) => ({ color: getStepColor(theme, completed) })}
                  />
                  <Text color={completed ? 'text.primary' : 'text.secondary'} variant="caption">
                    {formatCurrency(MILESTONES[index], '0')}
                  </Text>
                </Stack>
              </React.Fragment>
            )
          })}
          <Box
            sx={(theme) => ({
              bgcolor: getStepColor(theme, allCompleted),
              height: 2,
              mt: 12,
              width: 54,
            })}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default WithText
